import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
export default function MissingScopesMessage({
  missingPortalScopes,
  offeringType
}) {
  const scopeFeatures = missingPortalScopes.reduce((final, scope) => {
    const scopeFeatureI18nKey = `marketplace-assets-ui.scopeFeatures.${scope}`;
    if (isValidI18nKey(scopeFeatureI18nKey)) {
      final.push(I18n.text(scopeFeatureI18nKey));
    }
    return final;
  }, []);
  return scopeFeatures.length ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.details.missingPortalScopes",
    options: {
      count: scopeFeatures.length,
      offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}_lowercase`),
      scopeFeatures: I18n.formatList(scopeFeatures)
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.details.missingOtherPortalScopes",
    options: {
      offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}_lowercase`)
    }
  });
}